export class AwsNativePitrConfig {
    'retentionDays';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "retentionDays",
            "baseName": "retentionDays",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AwsNativePitrConfig.attributeTypeMap;
    }
    constructor() {
    }
}
